import type { NewsItem } from '@/types';

export const newsCategories = ['全部', '剧情分析', '演员动态', '预告速递', '行业资讯'];

export const news: NewsItem[] = [
  {
    id: 'news-01',
    title: '《首尔夜曲》第八集收视破 12%，雨中告白名场面封神',
    category: '剧情分析',
    date: '2026-10-08',
    summary: '最新一集播出后，全网讨论量瞬间飙升，男女主角在雨中的那场告白被观众称为“今年最好哭的三分钟”。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20rainy%20city%20street%20at%20night%2C%20warm%20neon%20reflections%20on%20wet%20pavement%2C%20romantic%20moody%20amber%20atmosphere%2C%20soft%20rain%20bokeh%2C%20high%20detail%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-01&orientation=landscape',
    content: [
      '《首尔夜曲》第八集播出后，收视率一路攀升，全国平均收视达到 12.4%，创下该剧开播以来的最高纪录。',
      '本集的高光时刻来自雨中告白：尹瑞妍终于把那首藏了十年的诗念了出来，而姜道贤在雨中停下脚步，回头说出了那句“我早就听见了”。短短三分钟，弹幕瞬间被泪水刷屏。',
      '编剧在采访中透露，这场戏的台词修改了整整十一稿，只为让情绪落在最自然的瞬间。导演则坚持实景拍摄，整段雨戏在真实雨夜里一次完成。',
      '从剧情结构来看，第八集也是全剧的转折点——两人此前各自的秘密开始交汇，为后续的高潮埋下伏笔。',
    ],
  },
  {
    id: 'news-02',
    title: '李知恩时隔两年回归小荧幕，新剧造型曝光引发热议',
    category: '演员动态',
    date: '2026-10-07',
    summary: '一组片场路透照流出，李知恩全新的短发造型与角色气质让粉丝直呼“完全认不出”。',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20editorial%20close%20up%20of%20an%20elegant%20young%20Korean%20actress%20with%20short%20dark%20hair%2C%20calm%20composed%20expression%2C%20warm%20neutral%20backdrop%2C%20cinematic%20natural%20lighting%2C%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-02&orientation=landscape',
    content: [
      '沉寂近两年后，李知恩确定以都市爱情剧《首尔夜曲》回归小荧幕。近日片场路透照曝光，她以一头干净利落的短发亮相，与过往温柔长发的形象截然不同。',
      '据制作方介绍，这个造型是为角色“尹瑞妍”量身打造的，象征着她从逃避到直面内心的转变。剧组造型师表示，短发让人物更有“深夜电台主播”的独立感。',
      '消息公布后，相关话题迅速登上热搜。不少观众表示，光是造型就已经对角色充满期待。',
    ],
  },
  {
    id: 'news-03',
    title: '《记忆迷宫》烧脑设定解析：时间线到底有几层？',
    category: '剧情分析',
    date: '2026-10-06',
    summary: '观众自发整理出时间线图谱，关于“谁在回忆”的讨论持续发酵，这里给出一份不含剧透的观看指南。',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20scene%20of%20glowing%20holographic%20memory%20fragments%20floating%20in%20a%20steel%20blue%20chamber%20with%20warm%20amber%20accents%2C%20surreal%20high%20detail%20concept%20art%2C%20no%20text&width=800&height=500&seq=kd-news-03&orientation=landscape',
    content: [
      '《记忆迷宫》播出至今，最让观众上头的就是它层层嵌套的叙事。剧中，记忆可以被读取与编辑，而主角每潜入一层，观众就要重新怀疑一次“现在”属于谁。',
      '本文从叙事结构出发，梳理出至少三条可辨识的时间线，并解释为何同一段回忆在不同角色视角下会呈现不同细节。',
      '值得注意的是，剧集刻意用色调区分层级：冷蓝代表被修改的记忆，暖橙代表尚未被触碰的真实。留意画面色彩，你就能提前一步猜到走向。',
      '制作方提醒，本剧建议按顺序观看，跳集很容易错过关键伏笔。',
    ],
  },
  {
    id: 'news-04',
    title: '宋康昊、全智贤确认合作新片，阵容堪称年度最强',
    category: '演员动态',
    date: '2026-10-05',
    summary: '两位顶级演员将首次同框出演一部科幻悬疑题材作品，消息一出即引爆行业期待。',
    cover: 'https://readdy.ai/api/search-image?query=Sophisticated%20dark%20editorial%20scene%20with%20two%20elegant%20empty%20director%20chairs%20under%20dramatic%20spotlight%2C%20warm%20amber%20and%20charcoal%20tones%2C%20cinematic%20prestige%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-04&orientation=landscape',
    content: [
      '据多家媒体确认，宋康昊与全智贤将首次合作，出演一部科幻悬疑题材的新作品。这也是两人出道以来第一次正式同框。',
      '知情人士透露，该项目筹备超过三年，剧本历经多轮打磨，主打“记忆与身份”的主题，与近期热播的《记忆迷宫》在类型上形成呼应。',
      '业内普遍认为，这一组合的号召力极强，无论票房还是口碑都值得期待。',
    ],
  },
  {
    id: 'news-05',
    title: '十月韩剧前瞻：五部新剧定档，题材覆盖悬疑与爱情',
    category: '预告速递',
    date: '2026-10-04',
    summary: '十月将迎来一波新剧集中上线，从高能悬疑到治愈爱情，总有一部适合你。',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20modern%20editorial%20scene%20of%20a%20row%20of%20glowing%20cinema%20marquee%20lights%20in%20warm%20amber%20tones%2C%20festive%20anticipation%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-05&orientation=landscape',
    content: [
      '十月档期竞争激烈，目前已确认至少五部新剧定档，涵盖悬疑、爱情、历史与家庭等主流题材。',
      '其中，两部悬疑剧主打“反转”卖点，一部爱情剧由人气演员领衔，另有一部历史正剧被视为年度黑马。',
      '平台方表示，今年十月的内容供给明显高于往年同期，观众的选择空间更大。本文为你整理各剧定档时间与看点，方便安排追剧日历。',
    ],
  },
  {
    id: 'news-06',
    title: '《王座之影》大结局收视创纪录，网友直呼意难平',
    category: '剧情分析',
    date: '2026-10-03',
    summary: '大结局播出后，“开放式结尾”引发两极讨论，编剧亲自回应了观众最关心的问题。',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20traditional%20Korean%20palace%20hall%20at%20dusk%20with%20torchlight%20and%20deep%20red%20banners%2C%20epic%20historical%20cinematic%20atmosphere%2C%20warm%20gold%20and%20ink%20black%20tones%2C%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-06&orientation=landscape',
    content: [
      '《王座之影》以 18.7% 的收视率迎来大结局，刷新该剧自身纪录，也创下同类题材近三年的最好成绩。',
      '然而结局并未给出“标准答案”，最后一场朝会留下的空白，让观众分成两派激烈讨论。有人认为是神来之笔，也有人直呼意难平。',
      '编剧在社交平台回应称：“王座上的影子从来不止一个，留白是我能想到最诚实的结局。”',
    ],
  },
  {
    id: 'news-07',
    title: '韩剧工业化观察：平台投资如何改变制作格局',
    category: '行业资讯',
    date: '2026-10-02',
    summary: '从单集成本到拍摄周期，全球流媒体平台的介入正在深刻重塑韩剧的制作方式。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20film%20studio%20sound%20stage%20with%20professional%20cameras%20and%20warm%20amber%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20sophisticated%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-07&orientation=landscape',
    content: [
      '过去十年，全球流媒体平台的持续投入，让韩剧的单集制作成本与拍摄规格大幅提升。',
      '制作方开始采用“全剧先拍后播”的模式，这既提高了成片质量，也让演员的档期安排更加苛刻。',
      '与此同时，题材也随之拓宽：科幻、惊悚、历史等以往投资较大的类型，如今有了更多落地空间。业内认为，这种变化将在未来两到三年内进一步加速。',
    ],
  },
  {
    id: 'news-08',
    title: '金泰梨谈《山茶花开》：这个角色让我哭了三个月',
    category: '演员动态',
    date: '2026-10-01',
    summary: '在最新专访中，金泰梨首次完整讲述了出演这部剧的心路历程与拍摄幕后。',
    cover: 'https://readdy.ai/api/search-image?query=Expressive%20editorial%20portrait%20of%20a%20Korean%20actress%20with%20intense%20eyes%20in%20muted%20warm%20lighting%2C%20thoughtful%20introspective%20mood%2C%20cinematic%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-08&orientation=landscape',
    content: [
      '在凭借《山茶花开》收获广泛好评后，金泰梨接受了本报专访。她坦言，这个角色是她演艺生涯中“情绪代价最大的一次”。',
      '“拍完最后一场戏，我在车里坐了整整一个小时。”她说，“那种感觉像是把一个人的人生还了回去。”',
      '为了贴近角色，她提前两个月住进小镇，跟着当地老人学做菜、学方言。她表示，正是这些生活细节，让表演有了根。',
      '谈及未来，她希望能尝试更多喜剧角色，“演哭戏演久了，也想演点能让人笑出声的”。',
    ],
  },
  {
    id: 'news-09',
    title: '《深渊回响》导演专访：真正的恐惧来自未知',
    category: '行业资讯',
    date: '2026-09-30',
    summary: '导演分享了这部惊悚剧在声音设计与实景拍摄上的诸多坚持。',
    cover: 'https://readdy.ai/api/search-image?query=Eerie%20flooded%20underground%20tunnel%20with%20still%20black%20water%20reflecting%20a%20single%20warm%20lamp%2C%20hanging%20mist%20and%20deep%20red%20glow%2C%20tense%20horror%20cinematic%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-09&orientation=landscape',
    content: [
      '《深渊回响》以极致的氛围感获得好评，导演在专访中透露，全剧超过七成场景为实景拍摄。',
      '“我们真的下过水。”他说，“演员在水里的恐惧是演不出来的，你只能把他们放进真实的环境里。”',
      '声音设计是本剧的另一大亮点。团队录制了上百种水流与回声样本，只为让观众在完全安静的时候，仍能感到有什么东西在靠近。',
      '对于“吓人”的定义，导演有自己的坚持：“真正的恐惧来自未知。当你把怪物完整展示出来，恐惧就结束了。”',
    ],
  },
  {
    id: 'news-10',
    title: '韩素希加盟《月光医院》第二季？制作方回应来了',
    category: '演员动态',
    date: '2026-09-29',
    summary: '针对网络传闻，制作方首次作出回应，透露了第二季的筹备进度。',
    cover: 'https://readdy.ai/api/search-image?query=Calm%20quiet%20hospital%20corridor%20at%20night%20with%20soft%20moonlight%20and%20warm%20lamp%20glow%2C%20clean%20teal%20and%20amber%20tones%2C%20hopeful%20tender%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=800&height=500&seq=kd-news-10&orientation=landscape',
    content: [
      '随着《月光医院》口碑持续走高，关于第二季的消息不断。近日有传闻称韩素希将回归并担任更重要的角色。',
      '制作方回应称，第二季确实已在筹备中，剧本进入打磨阶段，但具体阵容尚未最终确定。',
      '“我们非常希望能保留原有的团队与演员。”制作方表示，“但一切都要以剧本为准，不希望为了续集而续集。”',
      '据悉，第二季计划延续第一季的温情基调，把视角放在社区医院之外，讲述更大的医疗群像。',
    ],
  },
];